/*
  商品ページ「似合う」ラベル(snippets/woo-fit-label.liquid)。
  仕様: Vault 01_WooStore/Personal_Styling_CRM/27_FIT_LABEL_PDP_SPEC.md

  - 骨格: 商品の adakust_fit.fit_types と、端末に残る骨格診断の結果(localStorage wsp_result_v1)
  - カラー: 選択中バリアントの色名を WOO COLOR PROFILE のエンジン(window.WCP_ENGINE)でシーズンに変換し、
    カラー診断の結果(localStorage wcp_result_v1)と照合する。対応表はエンジンと共有し、ここには持たない
  - 効果測定: 訪問者を表示群A/非表示群Bに固定で分け、Shopify.analytics.publish でカスタムイベントを出す。
    カートに入れた行には隠しプロパティ _fit_label(A/B)を付け、注文データで群別に数えられるようにする

  下の判定関数はDOMに依存しない(tests/fit-label.test.js で検証)。
*/
(function () {
  'use strict';

  var FIT_TYPES = ['straight', 'wave', 'natural'];
  var FIT_NAMES = { straight: 'ストレート', wave: 'ウェーブ', natural: 'ナチュラル' };
  var WSP_KEY = 'wsp_result_v1';
  var WCP_KEY = 'wcp_result_v1';
  var BUCKET_KEY = 'woo_fit_label_bucket';
  var MODES = ['baseline', 'ab', 'all'];

  function notExpired(record, now) {
    if (!record || typeof record !== 'object') return false;
    if (!record.expiresAt) return true;
    var t = Date.parse(record.expiresAt);
    return isNaN(t) || t >= now;
  }

  // 商品の fit_types(JSON)を既知のタイプだけに絞る。重複は除く
  function parseFitTypes(raw) {
    if (!Array.isArray(raw)) return [];
    var out = [];
    raw.forEach(function (t) {
      if (FIT_TYPES.indexOf(t) !== -1 && out.indexOf(t) === -1) out.push(t);
    });
    return out;
  }

  // 骨格診断の結果。期限切れ・壊れた記録は未診断(null)。hybrid はそのまま返す(表示側で個別の強調をしない)
  function wspFitType(record, now) {
    if (!notExpired(record, now)) return null;
    var t = record.fitType;
    return FIT_TYPES.indexOf(t) !== -1 || t === 'hybrid' ? t : null;
  }

  // カラー診断の結果。期限切れ・設定改定前(configVersion不一致)・壊れた記録は未診断(null)
  function wcpSeason(record, now, configVersion, seasons) {
    if (!notExpired(record, now)) return null;
    if (configVersion && record.configVersion !== configVersion) return null;
    return (seasons || []).indexOf(record.season) !== -1 ? record.season : null;
  }

  // 群の割り当て。baseline は全員B(保存しない)、all は全員A、ab は保存済みの群を優先し、無ければ乱数で決める
  function assignBucket(mode, stored, random) {
    if (mode === 'all') return 'A';
    if (mode !== 'ab') return 'B';
    if (stored === 'A' || stored === 'B') return stored;
    return random < 0.5 ? 'A' : 'B';
  }

  // 骨格ラベルの表示内容。商品にタイプが無ければ null
  function fitView(fitTypes, userType) {
    if (!fitTypes.length) return null;
    var personal = FIT_TYPES.indexOf(userType) !== -1 && fitTypes.indexOf(userType) !== -1;
    return {
      names: fitTypes.map(function (t) { return FIT_NAMES[t]; }),
      personal: personal,
      personalText: personal ? '骨格' + FIT_NAMES[userType] + 'のあなたに似合うアイテムです' : '',
      diagnosed: userType !== null && userType !== undefined
    };
  }

  // カラーラベルの表示内容。色名がシーズンに対応しなければ null
  function colorView(colorValue, engine, userSeason) {
    if (!engine || colorValue === null || colorValue === undefined) return null;
    var season = engine.seasonForColor(colorValue);
    if (!season) return null;
    var color = engine.normalizeColor(colorValue);
    var seasonName = engine.SEASON_NAMES[season];
    var personal = userSeason === season;
    return {
      season: season,
      text: personal
        ? color + 'は' + seasonName + 'のあなたにおすすめのカラーです'
        : 'このカラー(' + color + ')は' + seasonName + 'の方におすすめ',
      personal: personal,
      diagnosed: !!userSeason
    };
  }

  var api = {
    parseFitTypes: parseFitTypes,
    wspFitType: wspFitType,
    wcpSeason: wcpSeason,
    assignBucket: assignBucket,
    fitView: fitView,
    colorView: colorView,
    FIT_NAMES: FIT_NAMES
  };

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (typeof window === 'undefined' || !window.customElements || customElements.get('woo-fit-label')) return;

  function storage() {
    try {
      var s = window.localStorage;
      var k = '__woo_fit_label_probe__';
      s.setItem(k, '1');
      s.removeItem(k);
      return s;
    } catch (e) {
      return null;
    }
  }

  function readJson(s, key) {
    if (!s) return null;
    try {
      return JSON.parse(s.getItem(key));
    } catch (e) {
      return null;
    }
  }

  function readScript(root, selector, fallback) {
    var el = root.querySelector(selector);
    if (!el) return fallback;
    try {
      var v = JSON.parse(el.textContent);
      return v === null || v === undefined ? fallback : v;
    } catch (e) {
      return fallback;
    }
  }

  function publish(name, payload) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) {}
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  class WooFitLabel extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      var now = Date.now();
      var ls = storage();
      var engine = window.WCP_ENGINE || null;

      this.mode = MODES.indexOf(this.dataset.mode) !== -1 ? this.dataset.mode : 'baseline';
      this.showFit = this.dataset.showFit !== 'false';
      this.showColor = this.dataset.showColor !== 'false' && !!engine;
      this.engine = engine;
      this.productId = this.dataset.productId || '';
      this.fitTypes = this.showFit ? parseFitTypes(readScript(this, '[data-fit-label-types]', [])) : [];
      this.colors = readScript(this, '[data-fit-label-colors]', {});
      this.userType = wspFitType(readJson(ls, WSP_KEY), now);
      this.userSeason = engine ? wcpSeason(readJson(ls, WCP_KEY), now, engine.CONFIG_VERSION, engine.SEASONS) : null;
      this.fitRow = this.querySelector('[data-fit-label-fit]');
      this.colorRow = this.querySelector('[data-fit-label-color]');
      this.input = this.querySelector('[data-fit-label-input]');

      var initialColor = this.colors[this.dataset.initialVariant];
      var hasColor = this.showColor && !!colorView(initialColor, engine, null);
      // 対象商品(骨格タイプがある、または選択中の色がシーズンに対応する)でなければ、何もしない
      if (!this.fitTypes.length && !hasColor) return;

      var stored = ls ? ls.getItem(BUCKET_KEY) : null;
      this.bucket = assignBucket(this.mode, stored, Math.random());
      if (this.mode === 'ab' && ls && stored !== this.bucket) {
        try { ls.setItem(BUCKET_KEY, this.bucket); } catch (e) {}
      }

      this.formId = this.resolveFormId();
      if (this.input && this.formId) {
        this.input.setAttribute('form', this.formId);
        this.input.value = this.bucket;
        this.input.disabled = false;
      }

      if (this.bucket === 'A') {
        this.renderFit();
        this.renderColor(initialColor);
        this.hidden = false;
        this.subscribeVariant();
      }

      var fit = fitView(this.fitTypes, this.userType);
      var color = this.showColor ? colorView(initialColor, engine, this.userSeason) : null;
      publish('woo_fit_label_view', {
        product_id: this.productId,
        bucket: this.bucket,
        mode: this.mode,
        has_fit: !!fit,
        has_color: !!color,
        fit_match: !!(fit && fit.personal),
        color_match: !!(color && color.personal)
      });

      this.bindEvents();
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      if (this.onSubmit) document.removeEventListener('submit', this.onSubmit, true);
    }

    renderFit() {
      var row = this.fitRow;
      var view = fitView(this.fitTypes, this.userType);
      if (!row || !view) return;
      row.textContent = '';
      if (view.personal) row.appendChild(el('p', 'woo-fit-label__personal', view.personalText));
      var line = el('p', 'woo-fit-label__line');
      line.appendChild(el('span', 'woo-fit-label__title', '似合う骨格'));
      view.names.forEach(function (name) {
        line.appendChild(el('span', 'woo-fit-label__chip', name));
      });
      row.appendChild(line);
      if (!view.diagnosed) row.appendChild(this.cta(this.dataset.wspUrl, '自分の骨格を診断する(約2分)', 'wsp'));
      row.hidden = false;
    }

    renderColor(colorValue) {
      var row = this.colorRow;
      if (!row) return;
      var view = this.showColor ? colorView(colorValue, this.engine, this.userSeason) : null;
      row.textContent = '';
      if (!view) {
        row.hidden = true;
        return;
      }
      row.appendChild(el('p', view.personal ? 'woo-fit-label__personal' : 'woo-fit-label__line', view.text));
      if (!view.diagnosed) row.appendChild(this.cta(this.dataset.wcpUrl, 'パーソナルカラーを診断する', 'wcp'));
      row.hidden = false;
    }

    // カスタムLiquidブロックの中からは main-product の変数 product_form_id が見えない(実測で空文字)。
    // 渡されていなければ、Dawnの命名規則 product-form-<section.id> を product-info の data-section から組み立てる
    resolveFormId() {
      var id = this.dataset.formId;
      if (!id) {
        var info = this.closest('product-info');
        if (info && info.dataset.section) id = 'product-form-' + info.dataset.section;
      }
      return id && document.getElementById(id) ? id : '';
    }

    cta(href, text, target) {
      var a = el('a', 'woo-fit-label__cta link', text);
      a.href = href;
      a.setAttribute('data-fit-label-cta', target);
      return a;
    }

    subscribeVariant() {
      var self = this;
      // constants.js の PUB_SUB_EVENTS はトップレベルの const で window のプロパティにならない。名前で参照する
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        self.renderColor(variant ? self.colors[String(variant.id)] : null);
      });
    }

    bindEvents() {
      var self = this;
      this.addEventListener('click', function (event) {
        var link = event.target.closest && event.target.closest('[data-fit-label-cta]');
        if (!link) return;
        publish('woo_fit_label_cta_click', {
          product_id: self.productId,
          bucket: self.bucket,
          target: link.getAttribute('data-fit-label-cta')
        });
      });

      var formId = this.formId;
      if (!formId) return;
      // product-form.js は submit を preventDefault して fetch で追加する。捕捉フェーズで先に拾う
      this.onSubmit = function (event) {
        var form = event.target;
        // 商品フォームには name="id" の入力があり、form.id はその要素を返す。属性で比べる
        if (!form || !form.getAttribute || form.getAttribute('id') !== formId) return;
        var idInput = form.querySelector('[name="id"]');
        publish('woo_fit_label_add_to_cart', {
          product_id: self.productId,
          variant_id: idInput ? String(idInput.value) : '',
          bucket: self.bucket
        });
      };
      document.addEventListener('submit', this.onSubmit, true);
    }
  }

  customElements.define('woo-fit-label', WooFitLabel);
})();
